import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { IconeVoltar } from './Icones.js';
import './Pagina.css';

type Props = {
  /** Linha de contexto acima do título (seção, data, procedência do registro). */
  readonly contexto: ReactNode;
  readonly titulo: ReactNode;
  /** Destino do botão de voltar; ausente, o botão não existe. */
  readonly voltarPara?: string;
  readonly acoes?: ReactNode;
  /** Faixa de filtros — no painel ela é SEMPRE visível, nunca escondida em menu. */
  readonly filtros?: ReactNode;
  /** Faixa livre logo abaixo do cabeçalho (ex.: ações em massa da seleção). */
  readonly faixa?: ReactNode;
  readonly children: ReactNode;
};

/**
 * Moldura interna de uma tela: cabeçalho com contexto e título, faixa de
 * filtros e área de conteúdo. Toda página do painel passa por aqui, então o
 * respiro do cabeçalho e do conteúdo são iguais em todas.
 *
 * A identidade e a saída não moram mais aqui: vivem na barra superior da
 * folha (`app/BarraSuperior`), uma vez só para todas as telas.
 */
export function Pagina({ contexto, titulo, voltarPara, acoes, filtros, faixa, children }: Props) {
  return (
    <div className="pagina">
      <header className="pagina__cabecalho">
        {voltarPara !== undefined && (
          <Link className="pagina__voltar" to={voltarPara} aria-label="Voltar">
            <IconeVoltar tamanho={16} />
          </Link>
        )}
        <div className="pagina__identidade">
          <span className="pagina__contexto">{contexto}</span>
          <h1 className="pagina__titulo">{titulo}</h1>
        </div>
        {acoes !== undefined && <div className="pagina__acoes">{acoes}</div>}
      </header>

      {faixa}

      {filtros !== undefined && <div className="pagina__filtros">{filtros}</div>}

      <div className="pagina__conteudo">{children}</div>
    </div>
  );
}
